// extracted by mini-css-extract-plugin
export default {"scrollArea":"scroll-area_scrollArea__hMfau","greyScrollbar":"scroll-area_greyScrollbar__v+ure","narrowScrollbar":"scroll-area_narrowScrollbar__tQo-l"};